import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Trash2, MoreHorizontal } from 'lucide-vue-next'
  import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger
  } from '@/components/ui/dropdown-menu'
  import { Button } from '@/components/ui/button'
  import useEventsBus from "@/utils/eventBus";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RciDataTableDropDown',
  props: {
    object: {}
  },
  setup(__props: any) {

  const props = __props

  const { emit } = useEventsBus()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenu), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            class: "w-8 h-8 p-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MoreHorizontal), { class: "w-4 h-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenuContent), { align: "end" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DropdownMenuLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(emit)('delete_rci', props.object)), ["prevent"])),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Trash2), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.delete')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})